module.exports = __webpack_public_path__ + "media/customizations/nolina/back-e9c9bac9626e2dbae684d2237a047cde.jpg";